// extracted by mini-css-extract-plugin
export default {"canvas":"GraphicsCanvas_canvas__Kp47g"};